import { Icon, tableFieldStyles } from "@prismicio/editor-ui"
import {
  NodeViewContent,
  type NodeViewProps,
  NodeViewWrapper,
} from "@tiptap/react"
import { useRef } from "react"

export function TableControlsWrapper({ editor }: NodeViewProps) {
  const contentRef = useRef<HTMLDivElement>(null)

  const isTableActive =
    editor.isActive("table") && editor.isActive("innerTable")

  function addColumnToEnd() {
    const executed = editor.commands.addColumnToEnd()
    if (executed && contentRef.current) {
      // scroll to the right to see the new column
      contentRef.current.scrollLeft = contentRef.current.scrollWidth
    }
  }

  return (
    <NodeViewWrapper
      ref={contentRef}
      className={tableFieldStyles.tableWithControls}
    >
      <div className={tableFieldStyles.tableOuterWrapper}>
        <NodeViewContent />
        <button
          type="button"
          className={tableFieldStyles.addTableRowButton}
          onClick={editor.commands.addRowToEnd}
          aria-disabled={!isTableActive}
          aria-label="Add row"
          title="Add row"
        >
          <Icon name="add" size="small" />
        </button>
      </div>
      <button
        type="button"
        className={tableFieldStyles.addTableColumnButton}
        onClick={addColumnToEnd}
        aria-disabled={!isTableActive}
        aria-label="Add column"
        title="Add column"
      >
        <Icon name="add" size="small" />
      </button>
    </NodeViewWrapper>
  )
}
